import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-managed',
  templateUrl: './managed.component.html',
  styleUrls: ['./managed.component.css']
})
export class ManagedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
